import * as React from "react"

function SvgFeatherSkipBack(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather-skip-back_svg__feather feather-skip-back_svg__feather-skip-back"
      {...props}
    >
      <path d="M19 20L9 12l10-8v16zM5 19V5" />
    </svg>
  )
}

export default SvgFeatherSkipBack
